import TestimonialSlides from '@/domain/Testimonials/TestimonialSlides';
import * as testimonials from './testimonials';

export default function PartnersTestimonials() {
  return (
    <TestimonialSlides
      testimonials={[testimonials.ge360, testimonials.fymConsulting]}
    />
  );
}
